// extracted by mini-css-extract-plugin
export default {"root":"RSo81","item":"k9fDT","itemTitle":"O2Yi2","itemInner":"KKOGl"};